import { render } from "./SurfaceFeatureIcon.vue?vue&type=template&id=0665e5d1"
import script from "./SurfaceFeatureIcon.vue?vue&type=script&lang=js"
export * from "./SurfaceFeatureIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__